// src/contexts/TimerContext.js
import React, { createContext, useContext, useState, useRef } from "react";

const TimerContext = createContext();

export function useTimer() {
  return useContext(TimerContext);
}

export function TimerProvider({ children }) {
  const [timerState, setTimerState] = useState({
    running: false,
    startedAt: null,
    seconds: 25 * 60,
    activityName: "",
    activityCategory: "",
    activityDate: "",
    workDuration: 25,
    breakDuration: 5,
    paused: false,
    mode: "work", // เพิ่มสำหรับ Pomodoro
    cycles: 0,
  });

  const intervalRef = useRef(null);
  const finishCallbackRef = useRef(null);

  // --- Start Timer ---
  const startTimer = (activity = {}) => {
    clearInterval(intervalRef.current);
    setTimerState((prev) => ({
      ...prev,
      running: true,
      paused: false,
      startedAt: new Date(),
      seconds: prev.workDuration ? prev.workDuration * 60 : 25 * 60,
      ...activity,
      mode: "work",
    }));
    finishCallbackRef.current = activity.onFinish || null;
  };

  // --- Stop Timer ("Finish") ---
  const stopTimer = () => {
    setTimerState((prev) => {
      if (prev.running && prev.startedAt) {
        const finishedAt = new Date();
        // Use wall-clock elapsed time, not countdown remaining, for accuracy
        const duration_seconds = Math.max(0, Math.round((finishedAt - new Date(prev.startedAt)) / 1000));
        const timerData = {
          startedAt: prev.startedAt,
          finishedAt,
          duration_seconds,
          duration: {
            hours: Math.floor(duration_seconds / 3600),
            minutes: Math.floor((duration_seconds % 3600) / 60),
            totalMinutes: Math.floor(duration_seconds / 60),
          },
          activityName: prev.activityName,
          activityCategory: prev.activityCategory,
          activityDate: prev.activityDate,
        };
        // Callback to whoever started timer
        if (finishCallbackRef.current) {
          finishCallbackRef.current(timerData);
        }
      }
      clearInterval(intervalRef.current);
      return {
        running: false,
        startedAt: null,
        seconds: prev.workDuration ? prev.workDuration * 60 : 25 * 60,
        activityName: "",
        activityCategory: "",
        activityDate: "",
        workDuration: prev.workDuration,
        breakDuration: prev.breakDuration,
        paused: false,
        mode: "work",
        cycles: 0,
      };
    });
  };

  // --- Cancel Timer ---
  const cancelTimer = () => {
    setTimerState((prev) => ({
      running: false,
      startedAt: null,
      seconds: prev.workDuration ? prev.workDuration * 60 : 25 * 60,
      activityName: "",
      activityCategory: "",
      activityDate: "",
      workDuration: prev.workDuration,
      breakDuration: prev.breakDuration,
      paused: false,
      mode: "work",
      cycles: 0,
    }));
    clearInterval(intervalRef.current);
    finishCallbackRef.current = null;
  };

  // ... เพิ่ม logic pause/resume ถ้าต้องการ

  return (
    <TimerContext.Provider value={{
      timerState,
      setTimerState,
      startTimer,
      stopTimer,
      cancelTimer,
      intervalRef,
    }}>
      {children}
    </TimerContext.Provider>
  );
}